import { GET_LIST } from 'react-admin';

const mapRewardsActionsList = ({ response }) => {
  const items = response?.json?.items || [];
  const total = response?.json?.total ?? items.length;

  return {
    ...response,
    json: items,
    total,
  };
};

export default {
  [GET_LIST]: mapRewardsActionsList,
};
